var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15237_24759)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.19336,
    y: 2.02344,
    width: 17,
    height: 17,
    rx: 4.5,
    fill: "white",
    stroke: "#C7D3DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.502 10.5278C10.502 9.86957 11.0356 9.33594 11.6938 9.33594C12.3521 9.33594 12.8857 9.86957 12.8857 10.5278C12.8857 11.1861 12.3521 11.7197 11.6938 11.7197C11.0356 11.7197 10.502 11.1861 10.502 10.5278Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.502 6.35596C10.502 5.69769 11.0356 5.16406 11.6938 5.16406C12.3521 5.16406 12.8857 5.69769 12.8857 6.35596C12.8857 7.01422 12.3521 7.54785 11.6938 7.54785C11.0356 7.54785 10.502 7.01422 10.502 6.35596Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.502 14.6997C10.502 14.0414 11.0356 13.5078 11.6938 13.5078C12.3521 13.5078 12.8857 14.0414 12.8857 14.6997C12.8857 15.358 12.3521 15.8916 11.6938 15.8916C11.0356 15.8916 10.502 15.358 10.502 14.6997Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15237_24759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0.693359 21.5234) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/SettingIcon.54e113e6a6126a5b5a3ff3bfb36cdf2e.svg";
export { ForwardRef as ReactComponent };